export enum Verification {
  IPIN = 'IPIN',
  SMS = 'SMS',
}

export type VerificationType = keyof typeof Verification;

export const VerificationTextMap: Record<VerificationType, string> = {
  IPIN: '아이핀',
  SMS: '휴대폰',
};
